
import React from "react";
import Links from "./Links";
import Support from "./support/Support";
import { i18nManager } from "../../../../i18n";
import { Navigate, Route, Routes, useSearchParams } from "react-router-dom";
import { IPlatform, IProfile } from "../../../../services";
import { DashboardContainer } from "../../../shared/DashboardContainer";
import { Utils } from "../../../../utils";
import Tickets from "./tickets/Tickets";

export interface ManagementProps {
    search: string;
    profile: IProfile;
    platform?: IPlatform;
}

function Management(props: ManagementProps) {
    const loading = !props.platform;
    const [searchParams, _] = useSearchParams(window.location.search);
    const search = Utils.urlParamsToSearch(searchParams, ["platform_id"]);
    const labels = i18nManager.Labels.dashboard.platform_management.management;

    return DashboardContainer({
        ...labels,
        search: props.search,
        title: (<React.Fragment>{labels.title} ({loading ? (<i className="fa fa-spinner fa-spin" />) : (props.platform?.platform_id ?? '')})</React.Fragment>),
        content: (<Routes>
            <Route path="/links" element={<Links platform={props.platform} />} />
            <Route path="/support/*" element={<Support platform={props.platform} />} />
            <Route path="/ticket-requests/*" element={<Tickets profile={props.profile} platform={props.platform} />} />
            <Route path="/ticket-requests" element={<Navigate to={{ pathname: "/dashboard/management/ticket-requests/requests", search }} />} />
            <Route path="/support" element={<Navigate to={{ pathname: "/dashboard/management/support/faqs", search }} />} />
        </Routes>),
    });
}

export default Management;
